import type {
  IssuedSnapshotAssignmentEntry,
  IssuedSnapshotAssignmentsRoot,
} from "@vTypes/snapshot-type";

function isIssuedSnapshotAssignmentEntry(
  v: unknown
): v is IssuedSnapshotAssignmentEntry {
  if (v == null || typeof v !== "object" || Array.isArray(v)) return false;
  const o = v as Record<string, unknown>;
  return (
    typeof o.reason === "string" &&
    typeof o.start_date === "string" &&
    ("end_date" in o
      ? o.end_date === null || typeof o.end_date === "string"
      : true)
  );
}

/** API가 `{ transfer: { reason, target_group_id, ... } }` 형태로 줄 때 평탄화 */
function coerceToIssuedSnapshotAssignmentEntry(
  v: unknown
): IssuedSnapshotAssignmentEntry | null {
  if (isIssuedSnapshotAssignmentEntry(v)) {
    return v;
  }
  if (v != null && typeof v === "object" && !Array.isArray(v)) {
    const wrap = v as Record<string, unknown>;
    const inner = wrap.transfer;
    if (
      inner != null &&
      typeof inner === "object" &&
      !Array.isArray(inner) &&
      isIssuedSnapshotAssignmentEntry(inner)
    ) {
      return inner;
    }
  }
  return null;
}

/** 간호사별 `assignments[]` 원본 → 표시·Select용 엔트리 배열 */
export function normalizeIssuedAssignmentEntries(
  raw: unknown[] | null | undefined
): IssuedSnapshotAssignmentEntry[] {
  if (!raw?.length) return [];
  const out: IssuedSnapshotAssignmentEntry[] = [];
  for (const item of raw) {
    const e = coerceToIssuedSnapshotAssignmentEntry(item);
    if (e != null) out.push(e);
  }
  return out;
}

/** API `assignments` 루트를 안전히 파싱(빈 객체·미정 스키마 허용) */
export function parseIssuedSnapshotAssignmentsRoot(
  raw: unknown
): IssuedSnapshotAssignmentsRoot | undefined {
  if (raw == null || typeof raw !== "object" || Array.isArray(raw))
    return undefined;
  const o = raw as Record<string, unknown>;
  const out: IssuedSnapshotAssignmentsRoot = {};
  for (const [k, v] of Object.entries(o)) {
    if (!Array.isArray(v)) continue;
    const entries = normalizeIssuedAssignmentEntries(v);
    if (entries.length > 0) out[k] = entries;
  }
  return Object.keys(out).length > 0 ? out : undefined;
}
